<template>
  <div ref="courseList">
    <course-card
      v-for="(item, index) in data"
      :key="index"
      :index="index"
      :clickId="clickId"
      :keyName="`xeslog-${CardType}-click`"
      :dataExpTag="dataExpTag"
      :data="item"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CourseCard from '@/components/CourseCard'
export default {
  data() {
    return {}
  },
  props: ['data', 'CardType', 'clickId'],
  components: {
    CourseCard
  },
  mounted() {
    // this.courseExposureLog()
  },
  computed: {
    ...mapState({
      dataExpTag: state => state.SearchPage.dataExpTag
    })
  },
  methods: {
    courseExposureLog() {
      if (this.data && this.data.length > 0) {
        const list = this.data.map(item => {
          return {
            category: item.category,
            id: item.id,
            price: item.price,
            name: item.name,
            subjects: item.subjects,
            syllabusNum: item.syllabusNum
          }
        })
        this.xesLog(
          'exposure',
          { type: 'xeslog-searchCourseList-exposure', content: list },
          { target: this.$refs.courseList }
        )
      } else {
        this.xesLog(
          'exposure',
          { type: 'xeslog-searchCourseList-exposure', content: null },
          { target: this.$refs.courseList }
        )
      }
    },
    xesLog(eventName, { type = '', content = '', clickId = '', clickurl = '' }, event) {
      const XESLog = new this.$XESLog({
        key: type,
        clickid: clickId,
        content,
        clickurl
      })
      XESLog.push({ eventname: eventName, target: event.target }, this.$route)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ./src/views/SearchPage/components/CourseList.vue